import React from "react";

export default function StreakCard({ streaks }) {
  return (
    <div style={{
      background: "var(--white)",
      border: "1px solid var(--dust)",
      borderRadius: "16px",
      padding: "1.5rem",
      display: "flex",
      alignItems: "center",
      gap: "1.25rem",
      boxShadow: "var(--shadow)",
      transition: "background 0.3s ease, border-color 0.3s ease",
    }}>
      <div style={{ fontSize: "2.5rem", filter: "drop-shadow(0 2px 10px rgba(200, 146, 42, 0.25))" }}>🔥</div>
      <div>
        <div style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: "0.72rem",
          color: "var(--muted)",
          textTransform: "uppercase",
          letterSpacing: "0.12em",
          fontWeight: 600,
        }}>
          Reading Streak
        </div>
        <h3 style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "2.1rem",
          fontWeight: 700,
          color: "var(--gold)",
          margin: "4px 0 0",
          lineHeight: 1,
        }}>
          {streaks.currentStreak} <span style={{ fontSize: "1rem", color: "var(--ink)", fontWeight: 400 }}>days</span>
        </h3>
        <span style={{ fontSize: "0.74rem", color: "var(--muted)", display: "block", marginTop: "4px", opacity: 0.8 }}>
          Longest streak: {streaks.longestStreak} days
        </span>
      </div>
    </div>
  );
}
